import Lib from '../../commons/lib';

export default class Service {
  static blogUrl = window.location.origin + '/api/blog/';
  static helyszinUrl = window.location.origin + '/api/helyszin/';

  // BLOG START

  static initPost(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.blogUrl + 'post/init',
      args: { requestType: 'post-init' },
    }], fnDone);
  }

  static listPost(all, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.blogUrl + 'post/list',
      args: { requestType: 'post-list' },
      data: all
    }], fnDone);
  }

  static addPost(post, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'POST',
      url: Service.blogUrl + 'post',
      args: { requestType: 'post-post' },
      data: post
    }], fnDone);
  }

  static editPost(post, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'PUT',
      url: Service.blogUrl + 'post',
      args: { requestType: 'post-put' },
      data: post,
    }], fnDone);
  }

  static getPost(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.blogUrl + 'post',
      args: { requestType: 'post-get' },
      params: { id: id }
    }], fnDone);
  }

  static viewPost(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.blogUrl + 'post/view',
      args: { requestType: 'post-view-get' },
      params: { id: id }
    }], fnDone);
  }

  static deletePost(id, fnDone) {
    Lib.MicroServices.requestService([{
      method: 'DELETE',
      url: Service.blogUrl + 'post',
      args: { requestType: 'post-delete' },
      params: { id: id }
    }], fnDone);
  }

  // BLOG END

  // HELYSZIN START

  static listHelyszinSelect(fnDone) {
    Lib.MicroServices.requestService([{
      method: 'GET',
      url: Service.helyszinUrl + 'helyszin/list/select',
      args: { requestType: 'helyszin-list-select' },
      params: {tipus: "SAJAT"},
    }], fnDone);
  }

  // HELYSZIN END

  // EDITOR START 

  static listEditorImages(fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "GET",
          url: Service.blogUrl + "editor/list",
          args: { requestType: "editor-list-get" }
        }
      ],
      fnDone
    );
  }

  static uploadEditorImage(file, id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "POST",
          url: Service.blogUrl + "editor",
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
          data: file
        }
      ],
      fnDone
    );
  }

  static deleteEditorImages(id, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "DELETE",
          url: Service.blogUrl + 'editor',
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
        }
      ],
      fnDone
    );
  }

  static deleteEditorImage(id, imageName, fnDone) {
    Lib.MicroServices.requestService(
      [
        {
          method: "DELETE",
          url: Service.blogUrl + `editor/image/${imageName}`,
          args: { requestType: "editor-post" },
          params: { funkcioId: id },
        }
      ],
      fnDone
    );
  }

  //EDITOR END
}
